import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {Grid} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {diferenciasResources} from "../endpoints";
import MaterialTable from "material-table";
import tableicons from "../tableicons";
import DialogContentText from "@material-ui/core/DialogContentText";

class DialogEnviarCorreo extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            datos:[],
            selectedRow: null,
            progress:false,
            disabled:false,
        }
    }

    handleClick = ()=>{
        this.setState({progress:true, disabled:true})
        diferenciasResources.enviaMailRecuento().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if (result.message){
                this.setState({progress:false, disabled:false})
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
            console.log(error)
        });
    }

    getRecuento= () =>{
        diferenciasResources.getRecuento().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({datos:result.recuento})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    componentDidMount() {
        this.getRecuento()
    }

    render() {
        return (
            <div>
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={true}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Enviar correo</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Está seguro que desea enviar el reconteo y las revisiones realizadas?
                        </DialogContentText>
                        <div>
                            <MaterialTable
                                localization={{
                                    toolbar: {
                                        searchPlaceholder: 'Buscar'
                                    },
                                    body:{
                                        emptyDataSourceMessage: 'No hay datos para mostrar'
                                    }
                                }}
                                options={{
                                    pageSize: 10,
                                    pageSizeOptions: [10, 25, 50, 100],
                                    actionsColumnIndex: -1,
                                    searchFieldStyle: {
                                        width: "auto",
                                    },
                                    padding: "dense",
                                }}
                                icons={tableicons}
                                title="Reconteo"
                                data={this.state.datos}
                                columns={[
                                    { title: 'Articulo', field: 'articulo'},
                                    { title: 'Cantidad', field: 'cantidad' },
                                ]}
                                onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                            />
                        </div>
                        <Grid container justifyContent={"center"}>
                            <Grid item>
                                {this.state.progress? <CircularProgress style={{marginTop: '10px',justifySelf: 'center'}}/>: null}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={this.state.disabled} variant="contained" color="secondary" onClick={this.props.handleClose}>
                            Cancelar
                        </Button>
                        <Button disabled={this.state.disabled} variant="contained" color="primary" onClick={this.handleClick}>
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default DialogEnviarCorreo;